/* eslint react-hooks/immutability: ["warn"] */
import { hasOngoingTask } from "@coworker/app/src/components/RoomSettings/Molecules/MediaArticles.helper";
import { Media } from "@coworker/app/src/components/RoomSettings/types/media";
import { TaskLinks } from "@coworker/app/src/components/RoomSettings/types/taskLink";
import { AggregatedItemListViewItem } from "@coworker/apprestructured/src/media-maintenance/components/aggregated-items/AggegatedItemListViewItem/AggregatedItemListViewItem";
import { ItemStockInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemStock";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { AggregatedArticle } from "../hooks/useAggregatedArticles";
import "../styles/RoomSettings.css";
import { ArticleIdNbrArticles, EdsData, SalesStopData } from "../types/article";

interface AggregatedArticleListItemProps {
  article: AggregatedArticle;
  media: Media;
  itemInfo: Item | null;
  itemInfoLoading: boolean;
  taskLinks?: TaskLinks;
  edsData?: EdsData | null;
  salesStopData?: SalesStopData | null;
  badges4AK1?: string[];
  itemTags?: string[];
  selectArticleIdsMode?: boolean;
  isSelected?: boolean;
  stockInfo?: ItemStockInfo;
  handleSelectedItems?: (articleIdNbrArticles: ArticleIdNbrArticles) => void;
}

export function AggregatedArticleListItem({
  article,
  edsData,
  salesStopData,
  badges4AK1,
  itemTags,
  selectArticleIdsMode,
  isSelected,
  handleSelectedItems,
  taskLinks,
  media,
  itemInfo,
  stockInfo,
  itemInfoLoading,
}: AggregatedArticleListItemProps) {
  const handleSelectedItemChange = () => {
    if (handleSelectedItems) {
      handleSelectedItems({
        articleId: article.id,
        nbrArticles: article?.nbrArticles || 0,
      });
    }
  };

  if (!article) return <></>;

  // v1 task links plus the v2 flag derived in useCombinedArticles.
  // Must stay in sync with useTasksSelectArticleFilter.
  const aggregatedArticleIds = article.aggregatedArticles.map((a) => a.id);
  const hasOngoingTasks =
    hasOngoingTask(aggregatedArticleIds, taskLinks || []) ||
    !!article.hasV2Tasks;

  return (
    <>
      <AggregatedItemListViewItem
        edsData={edsData ?? null}
        salesStopData={salesStopData ?? null}
        showActions={!selectArticleIdsMode}
        selectArticleIdsMode={selectArticleIdsMode}
        isSelected={isSelected || false}
        article={article}
        hasOngoingTasks={hasOngoingTasks}
        media={media}
        itemInfo={itemInfo}
        stockInfo={stockInfo}
        itemInfoLoading={itemInfoLoading}
        badges4AK1={badges4AK1 ?? article.badges4AK1 ?? []}
        itemTags={itemTags ?? article.itemTags ?? []}
        handleSelectedItemChange={handleSelectedItemChange}
      />
    </>
  );
}
